<script>
    import {
        modalState
    } from '@app/store/modalStore.js';
    import {
        cliConfigState
    } from '@app/store/cliConfigStore.js';
    import {
        createEventDispatcher
    } from 'svelte';
    
    export let currentState;
    const dispatch = createEventDispatcher();
    
    function toggleMenu() {
        dispatch('toggleMenu', {
            menu: 'cli'
        });
    }
    </script>
    
    {#if $cliConfigState.filter(cliTool => {return cliTool.options[0].selected === "true"}).length > 0}
    <li class="nav-item dropdown {currentState ? 'show' : ''}" role="menuitem">
        <a on:click={toggleMenu} 
           class="dropdown-toggle nav-link" 
           href="#!/"
           id="cliMenuButton"
           aria-haspopup="true"
           aria-expanded={currentState}
           role="button"
           aria-label="CLI Tools menu">CLI Tools</a>
        <div class="dropdown-menu {currentState ? 'show' : ''}" 
             role="menu" 
             aria-labelledby="cliMenuButton">
            {#each $cliConfigState as cliType}
            <a class="dropdown-item" 
               href="#!/"
               on:click={() => modalState.showModal(cliType.modalName)}
               id="cli{cliType.name.replace(/\s+/g, '')}"
               role="menuitem"
               aria-label="Open {cliType.name}">{cliType.name}</a>
            {/each}
        </div>
    </li>
    {/if}
